function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "100%",
    height: "100%",
    viewBox: "0 0 229 98",
    xmlSpace: "preserve",
    fill: "white",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,4.65717,88.7632)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M25.125,-80.187C16.573,-80.187 9.943,-74.844 9.943,-63.187L9.943,-47.151L3.208,-47.151L3.208,-34.75L9.943,-34.75L9.943,0L25.979,0L25.979,-34.75L36.995,-34.75L36.995,-47.151L25.979,-47.151L25.979,-61.266C25.979,-65.865 26.839,-67.682 30.151,-67.682L36.995,-67.682L36.995,-80.187L25.125,-80.187Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,43.4688,88.7632)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 6.417,
    y: -80.187,
    width: 16.036,
    height: 80.188,
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,72.337,88.7632)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M5.557,-63.297C5.557,-58.167 9.729,-53.885 14.969,-53.885C20.099,-53.885 24.38,-58.167 24.38,-63.297C24.38,-68.536 20.099,-72.703 14.969,-72.703C9.729,-72.703 5.557,-68.536 5.557,-63.297ZM22.99,0L22.99,-47.151L6.948,-47.151L6.948,0L22.99,0Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,182.48,88.7632)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33.036,-35.281C35.495,-35.281 37.849,-34.536 39.453,-32.609L39.667,-32.609L39.667,-47.151C38.385,-47.792 36.245,-48.219 34.854,-48.219C28.974,-48.219 24.911,-44.906 22.453,-41.38L22.453,-47.151L6.417,-47.151L6.417,0L22.453,0L22.453,-23.521C22.453,-29.187 27.052,-35.281 33.036,-35.281Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-134,-201)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M254.938,220.484C248.5,226.068 244.474,233.964 242.479,242.146C238.302,259.266 243.906,280.823 261.49,287.917C266.453,289.922 271.891,290.339 277.193,290.365C282.76,290.385 288.318,289.406 293.531,287.458C304.078,283.521 312.109,275.26 318.12,265.979C318.682,265.12 317.448,264.099 316.854,264.969C311.021,273.542 303.615,281.151 293.932,285.24C284.531,289.208 272.432,289.828 262.792,286.359C243.563,279.443 239.641,254.698 245.776,237.536C248.781,229.12 254.557,221.578 262.604,217.484C270.839,213.302 281.646,212.885 289.599,217.891C296.875,222.469 301.208,230.87 301.568,239.349C301.958,248.734 296.458,257.198 287.896,260.896C280.927,263.901 272.432,263.25 267.214,257.958C272.365,258.943 278.802,256.479 282.573,253.688C283.474,253.021 282.5,251.776 281.568,252.307C279.776,253.328 277.88,254.266 275.932,254.953C273.922,255.661 271.656,256.302 269.51,256.281C268.094,256.271 266.453,256.036 265.245,255.25C264.354,254.672 263.271,253.76 262.688,252.865C262.031,251.854 260.656,252.938 261.208,253.938C264.51,259.964 267.792,265.594 273.182,270.042C273.88,270.62 274.724,269.547 274.052,268.953C270.464,265.792 267.505,262.62 265.146,258.115C270.828,263.682 276.688,265.344 284.177,263.766C292.526,262.01 299.333,255.922 301.99,247.833C307.099,232.286 295.589,214.031 279.177,212.635C270.344,211.88 261.63,214.682 254.938,220.484",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWhite);
export default __webpack_public_path__ + "static/media/icon_white.735413be042b955c81aebee9eeed9fae.svg";
export { ForwardRef as ReactComponent };